(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rotating-text"] && !Shopify.designMode) return;
  try {
    
  if ('customElements' in window && !window.customElements.get('upv-rotating-marquee')) {
    class UpvRotatingMarquee extends HTMLElement {
      connectedCallback() {
        if (this.upvConnected) return;
        this.upvConnected = true;
        this.upvButton = this.querySelector('.upv-rotating-text__control');
        this.upvMotionQuery = window.matchMedia
          ? window.matchMedia('(prefers-reduced-motion: reduce)')
          : null;
        this.upvPaused = this.upvPaused === true;
        this.upvHandleClick = this.upvHandleClick || this.handleUpvClick.bind(this);
        this.upvHandleMotionChange = this.upvHandleMotionChange || this.syncUpvMotion.bind(this);
        this.upvScheduleLayout = this.upvScheduleLayout || this.scheduleUpvLayout.bind(this);

        if (this.upvButton) this.upvButton.addEventListener('click', this.upvHandleClick);
        if (this.upvMotionQuery) {
          if (typeof this.upvMotionQuery.addEventListener === 'function') {
            this.upvMotionQuery.addEventListener('change', this.upvHandleMotionChange);
          } else if (typeof this.upvMotionQuery.addListener === 'function') {
            this.upvMotionQuery.addListener(this.upvHandleMotionChange);
          }
        }
        this.setupUpvVisibility();
        this.syncUpvMotion();
        this.setupUpvGeometry();
      }

      disconnectedCallback() {
        if (!this.upvConnected) return;
        this.teardownUpvGeometry();
        this.teardownUpvVisibility();
        if (this.upvButton) this.upvButton.removeEventListener('click', this.upvHandleClick);
        if (this.upvMotionQuery) {
          if (typeof this.upvMotionQuery.removeEventListener === 'function') {
            this.upvMotionQuery.removeEventListener('change', this.upvHandleMotionChange);
          } else if (typeof this.upvMotionQuery.removeListener === 'function') {
            this.upvMotionQuery.removeListener(this.upvHandleMotionChange);
          }
        }
        this.classList.remove('upv-rotating-text--ready');
        if (this.upvButton) this.upvButton.hidden = true;
        this.upvButton = null;
        this.upvMotionQuery = null;
        this.upvConnected = false;
      }

      setupUpvGeometry() {
        this.teardownUpvGeometry();
        const generation = this.upvGeometryGeneration;
        this.upvTracks = Array.from(this.querySelectorAll('.upv-rotating-text__track'));
        if (typeof window.ResizeObserver === 'function') {
          try {
            this.upvResizeObserver = new window.ResizeObserver(this.upvScheduleLayout);
            this.upvResizeObserver.observe(this);
          } catch (error) {
            if (this.upvResizeObserver) this.upvResizeObserver.disconnect();
            this.upvResizeObserver = null;
          }
        }
        if (!this.upvResizeObserver) {
          window.addEventListener('resize', this.upvScheduleLayout);
        }
        if (document.fonts) {
          document.fonts.ready.then(() => {
            if (this.upvConnected && generation === this.upvGeometryGeneration) {
              this.scheduleUpvLayout();
            }
          });
          if (typeof document.fonts.addEventListener === 'function') {
            document.fonts.addEventListener('loadingdone', this.upvScheduleLayout);
          }
        }
        this.scheduleUpvLayout();
      }

      teardownUpvGeometry() {
        this.upvGeometryGeneration = (this.upvGeometryGeneration || 0) + 1;
        if (this.upvResizeObserver) this.upvResizeObserver.disconnect();
        this.upvResizeObserver = null;
        window.removeEventListener('resize', this.upvScheduleLayout);
        if (document.fonts && typeof document.fonts.removeEventListener === 'function') {
          document.fonts.removeEventListener('loadingdone', this.upvScheduleLayout);
        }
        if (this.upvLayoutFrame) window.cancelAnimationFrame(this.upvLayoutFrame);
        this.upvLayoutFrame = 0;
        this.upvTracks = null;
      }

      scheduleUpvLayout() {
        if (!this.upvConnected || this.upvLayoutFrame) return;
        this.upvLayoutFrame = window.requestAnimationFrame(() => {
          this.upvLayoutFrame = 0;
          if (this.upvConnected) this.layoutUpvTracks();
        });
      }

      layoutUpvTracks() {
        if (
          this.dataset.motionEnabled !== 'true' ||
          (this.upvMotionQuery && this.upvMotionQuery.matches) ||
          !this.upvButton
        ) return;

        const viewportWidth = this.getBoundingClientRect().width;
        this.classList.add('upv-rotating-text--ready');
        let geometryReady = viewportWidth > 0 && Number.isFinite(viewportWidth);
        (this.upvTracks || []).forEach((track) => {
          if (!geometryReady) return;
          const groups = Array.from(track.querySelectorAll('.upv-rotating-text__group'));
          const firstCopy = groups[0] && groups[0].firstElementChild;
          const copyWidth = firstCopy ? firstCopy.getBoundingClientRect().width : 0;
          const copyCount = Math.ceil(viewportWidth / copyWidth) + 1;
          if (groups.length !== 2 || !Number.isFinite(copyCount) || copyCount < 2 || copyCount > 64) {
            geometryReady = false;
            return;
          }
          groups.forEach((group) => {
            while (group.children.length > copyCount) group.lastElementChild.remove();
            while (group.children.length < copyCount) {
              const copy = firstCopy.cloneNode(true);
              copy.dataset.marqueeCopy = String(group.children.length + 1);
              group.appendChild(copy);
            }
          });
          const groupWidth = groups[0].getBoundingClientRect().width;
          if (!Number.isFinite(groupWidth) || groupWidth < viewportWidth) {
            geometryReady = false;
            return;
          }
          const duration = `${groupWidth / 40}s`;
          if (track.style.getPropertyValue('--upv-marquee-duration') !== duration) {
            track.style.setProperty('--upv-marquee-duration', duration);
          }
        });
        this.classList.toggle('upv-rotating-text--ready', geometryReady);
        this.upvButton.hidden = !geometryReady;
      }

      setupUpvVisibility() {
        this.teardownUpvVisibility();
        const generation = this.upvVisibilityGeneration;
        if (typeof window.IntersectionObserver !== 'function') return;

        let observer = null;
        try {
          const target = typeof this.closest === 'function'
            ? (this.closest('section') || this)
            : this;
          observer = new window.IntersectionObserver((entries) => {
            this.handleUpvVisibility(entries, generation);
          }, {
            root: null,
            rootMargin: '120px 0px 120px 0px',
            threshold: 0
          });
          this.upvVisibilityObserver = observer;
          this.upvVisibilityTarget = target;
          this.classList.add('upv-rotating-text--visibility-owned');
          observer.observe(target);
        } catch (error) {
          if (observer && typeof observer.disconnect === 'function') observer.disconnect();
          this.upvVisibilityObserver = null;
          this.upvVisibilityTarget = null;
          this.classList.remove('upv-rotating-text--visibility-owned');
          this.classList.remove('upv-rotating-text--near-view');
        }
      }

      teardownUpvVisibility() {
        this.upvVisibilityGeneration = (this.upvVisibilityGeneration || 0) + 1;
        if (
          this.upvVisibilityObserver &&
          typeof this.upvVisibilityObserver.disconnect === 'function'
        ) {
          this.upvVisibilityObserver.disconnect();
        }
        this.upvVisibilityObserver = null;
        this.upvVisibilityTarget = null;
        this.classList.remove('upv-rotating-text--visibility-owned');
        this.classList.remove('upv-rotating-text--near-view');
      }

      handleUpvVisibility(entries, generation) {
        if (
          !this.upvConnected ||
          generation !== this.upvVisibilityGeneration ||
          !this.upvVisibilityObserver
        ) return;

        Array.from(entries || []).forEach((entry) => {
          if (!entry || entry.target !== this.upvVisibilityTarget) return;
          this.classList.toggle(
            'upv-rotating-text--near-view',
            Boolean(entry.isIntersecting)
          );
        });
      }

      handleUpvClick() {
        this.upvPaused = !this.upvPaused;
        this.syncUpvControl();
      }

      syncUpvMotion() {
        const motionEnabled = this.dataset.motionEnabled === 'true';
        const reducedMotion = Boolean(this.upvMotionQuery && this.upvMotionQuery.matches);
        const canRun = motionEnabled && !reducedMotion && Boolean(this.upvButton);
        this.classList.toggle('upv-rotating-text--ready', canRun);
        if (this.upvButton) this.upvButton.hidden = !canRun;
        this.syncUpvControl();
        if (canRun) this.scheduleUpvLayout();
      }

      syncUpvControl() {
        this.classList.toggle('upv-rotating-text--paused', this.upvPaused);
        if (!this.upvButton) return;
        const label = this.upvPaused
          ? this.upvButton.dataset.resumeLabel
          : this.upvButton.dataset.pauseLabel;
        this.upvButton.setAttribute('aria-pressed', String(this.upvPaused));
        this.upvButton.setAttribute('aria-label', label);
        this.upvButton.title = label;
      }
    }

    window.customElements.define('upv-rotating-marquee', UpvRotatingMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
